module.exports = __webpack_public_path__ + "static/media/eyescan12.f3a7e0c4.png";